//@ts-check
/**
 * The one failure banner, shared by every sheet that saves in the background.
 *
 * Sheets close the instant you save, so by the time a request fails the component that made it
 * may be gone. The banner therefore lives in the layout and is raised through this store.
 *
 * An installed PWA has no address bar and no reload, so a banner with no way out is a banner
 * forever — the app has to be force-quit to clear it. It dismisses itself, and a tap kills it
 * sooner.
 */

/** @type {{ error: string, cheer: string }} */
export const notice = $state({ error: "", cheer: "" });

/** @type {ReturnType<typeof setTimeout> | undefined} */
let timer;
/** @type {ReturnType<typeof setTimeout> | undefined} */
let cheerTimer;

/**
 * A moment worth marking — getting a thing you wanted. Brief, and it asks nothing of anyone.
 *
 * @param {string} message already translated
 */
export function showCheer(message) {
  notice.cheer = message;
  clearTimeout(cheerTimer);
  cheerTimer = setTimeout(() => (notice.cheer = ""), 2400);
}

/** @param {string} message already translated */
export function showError(message) {
  notice.error = message;
  clearTimeout(timer);
  timer = setTimeout(() => (notice.error = ""), 6000);
}

export function dismissError() {
  clearTimeout(timer);
  notice.error = "";
}
